import React, { useState, useEffect } from "react";
import Confetti from "react-confetti";
import { FaChevronCircleUp } from "react-icons/fa";
import { BiLeftArrowAlt } from "react-icons/bi";
import StakeholderSummaryCard from "./StakeholderSummaryCard.jsx";

const CompletionScreen = ({
  stakeholderData,
  stakeholder,
  stakeholderNumber = 1,
  userId,
  subsectionId,
  onSubsectionChange,
  onNext,
  onEditProfile,
  onBackToSelection,
  userName = "",
  showEditProfile = false,
  showContinue = false,
  continueButtonText = "Continue",
}) => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // Update window size for confetti
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleContinue = () => {
    if (typeof onNext === "function") {
      onNext();
    }
  };

  // Show confetti only when not showing buttons (preview phase)
  const showConfetti = !showEditProfile && !showContinue;

  return (
    <div className="w-full min-h-auto flex flex-col items-center justify-center py-0 bg-white relative overflow-hidden">
      {/* Confetti - Only in preview phase */}
      {showConfetti && (
        <Confetti
          width={windowSize.width}
          height={windowSize.height}
          numberOfPieces={200}
          recycle={true}
          colors={["#5303BB", "#54B0AF", "#FF6B35", "#F7931E", "#FFD700", "#000000"]}
        />
      )}

      {/* Success Message - Only in preview phase */}
      {showConfetti && (
        <div className="text-center mb-5 z-10">
          <h1 className="text-2xl md:text-[32px] font-medium text-[#323232] font-gotham">
            You did homework on {stakeholder?.name?.split(" ")[0]}, {userName}!
          </h1>
        </div>
      )}

        {showEditProfile && stakeholderNumber === 2 && (
    <button
      onClick={() => {
        // Go back to selection to change stakeholder 2
        if (onBackToSelection) onBackToSelection();
      }}
      className="mb-2 text-sm text-gray-500 hover:text-gray-700 transition-colors flex items-center gap-1"
    >
      <span>
        <BiLeftArrowAlt className="w-5 h-5 text-[#838383]" />
      </span>
      <span className="text-xs md:text-[15px] text-[#838383] font-gotham font-medium uppercase tracking-wide">
        CHANGE STAKEHOLDER
      </span>
    </button>
  )}

      {/* Edit Profile Link - Only when showEditProfile is true */}
      {showEditProfile && (
        <button
          onClick={onEditProfile}
          className="mb-4 text-sm text-gray-500 hover:text-gray-700 transition-colors flex items-center gap-1"
        >
          <span>
            <BiLeftArrowAlt className="w-5 h-5 text-[#838383]" />
          </span>
          <span className="text-xs md:text-[15px] text-[#838383] font-gotham font-medium uppercase tracking-wide">
            EDIT PROFILE
          </span>
        </button>
      )}

      {/* Stakeholder Card - Always visible */}
      <div className="max-w-md mx-auto mb-8">
        <StakeholderSummaryCard
          stakeholder={stakeholder}
          data={stakeholderData}
          stakeholderNumber={stakeholderNumber}
        />
      </div>

      {/* Continue Button - Only when showContinue is true */}
      {showContinue && (
        <div className="text-center">
          <button
            onClick={handleContinue}
            className="inline-flex items-center gap-3 px-10 py-4 bg-[#54B0AF] font-gotham font-medium hover:bg-teal-600 text-white font-medium text-lg md:text-xl rounded-full shadow-lg hover:shadow-xl transition-all"
          >
            {continueButtonText} 
            <span>
              <FaChevronCircleUp className="rotate-90 ml-2" />
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

export default CompletionScreen;